export default __webpack_public_path__ + "static/media/react.d1d00361.png";